import {CHANGE_PRODUCT, EMPTY_CFG, LOAD_ITEMS_TO_CFG} from '../actions/actionTypes';

export const INITIAL_STATE = { selection: {}, count: 0, id: null,};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case CHANGE_PRODUCT:
            const selection = Object.assign({}, state.selection);

            selection[action.payload.productId] = action.payload.amount;

            if (selection[action.payload.productId] === 0) {
                delete selection[action.payload.productId];
            }

            return { ...state, selection: selection, count: updateCount(selection) };

        case EMPTY_CFG:
            return INITIAL_STATE;

        case LOAD_ITEMS_TO_CFG:
            const newSelection = action.payload.items;
            const id = action.payload.id;

            return { ...state, selection: newSelection, count: updateCount(newSelection), id: id };
        default:
            return state;
    }
}

function updateCount(selection) {
    let count = 0;
    Object.keys(selection).forEach(key => {
        count = count + selection[key];
    });
    return count;
}
